// assets
import RestoreFromTrashTwoToneIcon from '@mui/icons-material/RestoreFromTrashTwoTone';

export const state = {};

export const reducer = {};

export const gridActions = (row, permissionData, onClickActions) => {
    const gridActions = [];

    permissionData?.forEach((perm) => {
        switch (perm) {
            case 'canRestoreDeleted':
                if (!row?.deletedAt) {
                    return;
                }

                gridActions.push({
                    key: `actionrestoredeleted-row${row?.id}`,
                    icon: <RestoreFromTrashTwoToneIcon fontSize="small" />,
                    label: 'ui-comp-button-restoredeleted',
                    position: 4,
                    showInMenu: true,
                    onClick: () => {
                        if (
                            'onClickRowActionRestoreDeleted' in (onClickActions || {}) &&
                            typeof onClickActions.onClickRowActionRestoreDeleted === 'function'
                        ) {
                            onClickActions.onClickRowActionRestoreDeleted(row);
                        }
                    }
                });
                break;
            default: // do nothing
        }
    });

    return gridActions;
};
